import { render, staticRenderFns } from "./marked.vue?vue&type=template&id=66b785c4&scoped=true&"
import script from "./marked.vue?vue&type=script&lang=js&"
export * from "./marked.vue?vue&type=script&lang=js&"
import style0 from "./marked.vue?vue&type=style&index=0&id=66b785c4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b785c4",
  null
  
)

export default component.exports